import React, { createContext, useContext } from 'react';
const MediaContext = /*#__PURE__*/createContext(undefined);
export const MediaProvider = ({
  children,
  mediaContext
}) => {
  return /*#__PURE__*/React.createElement(MediaContext.Provider, {
    value: mediaContext
  }, children);
};

/*
 * This is used for the Proforma attachment field which needs media tokens which are passed down from the portal or Jira frontend
 * */
export function useMediaContext() {
  const mediaContext = useContext(MediaContext);
  const {
    mediaApiUploadToken,
    mediaApiReadToken,
    projectId,
    portalId,
    issueKey,
    mediaUploadAndViewContexts,
    mediaReadTokenRefresh,
    mediaApiError
  } = mediaContext !== null && mediaContext !== void 0 ? mediaContext : {};
  return {
    mediaApiUploadToken,
    mediaApiReadToken,
    mediaUploadAndViewContexts,
    projectId,
    portalId,
    issueKey,
    mediaReadTokenRefresh,
    mediaApiError
  };
}